import { routes } from "./urls";

export const navigationShortcuts = [
  { key: "h", label: "Home", route: routes.index },
  { key: "c", label: "Chat", route: routes.chats, personalWork: true },
  { key: "p", label: "Personal", route: routes.personal, personalWork: true },
  { key: "l", label: "Links", route: routes.links },
  { key: "o", label: "Connectors", route: routes.connectors },
  { key: "k", label: "Skills", route: routes.skills },
  { key: "m", label: "Monitoring", route: routes.monitoring },
  { key: "s", label: "Settings", route: routes.settings },
] as const;
